import { render } from "./Face.vue?vue&type=template&id=4562d023&scoped=true&ts=true"
import script from "./Face.vue?vue&type=script&lang=ts"
export * from "./Face.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=4562d023&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4562d023"]])

export default __exports__